import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitBooking(payload) {
  const { data } = await api.post("/bookings", payload);
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

export async function fetchAnimals() {
  const { data } = await api.get("/animals");
  return data.animals;
}

export async function fetchPackages() {
  const { data } = await api.get("/packages");
  return data.packages;
}
